module.exports = __webpack_public_path__ + "img/PlayersTrust_H_LBG_RGB.c1285741.png";